var SCM = SCM || {};

(function (ns, $) {
        
    ns.AddMetadataBorder = function () {
        // Abstract or extract exists
        if ($('.js-chapter-abstract-wrap').length || $('.js-book-abstract-wrap').length) {
            $('.js-metadata-panel').addClass('add-border');
        }
    };

   
    ns.init = function () {
        ns.AddMetadataBorder();
    };
}

)(SCM.BookMetadata = SCM.BookMetadata || {}, jQuery);